import initPeopleSearch from './components/people/people-search';

const peopleListing = document.querySelector('.js-people-listing');

if (peopleListing) {
    initPeopleSearch(peopleListing);
}
